module.exports = __webpack_public_path__ + "img/br.20797008.svg";